import { prettyPrintDate } from "./formatting";

export function generateCsv(
  rows: Array<any>[],
  save?: boolean,
  filename?: string
): string {
  let mediaType = 'data:text/csv;charset=utf-8,',
      rowStr = rows.map(row => generateRowString(row)).join('\n'),
      content = encodeURIComponent(`\uFEFF` + rowStr),
      dataUri = `${mediaType}${content}`;
  if(save)
    download(dataUri, filename);
  return dataUri;
}

function generateCellString(data: any){
  if(typeof data !== 'string')
    data = `${data}`;
  return `"${data.replaceAll('"', '"""')}"`;
}

function generateRowString(data: any[]){
  return data.map(cell => generateCellString(cell)).join(',');
}

function getDownloadElement(){
  let shdl = document.getElementById('shdl');
  if(!shdl){
    shdl = document.createElement("a");
    shdl.setAttribute('id', 'shdl');
    shdl.setAttribute('style', 'display: none;');
    shdl.innerHTML = "(ꈍᴗꈍ✿)";
    document.body.appendChild(shdl);
  }
  return shdl;
}

function download(url: string, filename?: string){
  let shdl = getDownloadElement();
  shdl.setAttribute('href', url);
  shdl.setAttribute('download', (filename || `Skyhawk ${prettyPrintDate({fs: true})}`));
  shdl.click();
}